import {NgModule} from '@angular/core';
import {UpgradeComponent} from './upgrade.component';
import {DialogModule} from 'primeng/dialog';
import {CommonModule} from '@angular/common';
import {CarouselModule} from 'primeng/carousel';
import {CarouselsModule} from '../carousels/carousels.module';
import {ButtonModule} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {CountdownBannerComponent} from '../countdown-banner/countdown-banner.component';
import {SharedModule} from '../shared/shared.module';
import {StyleClassModule} from 'primeng/styleclass';
import {RouterLink} from '@angular/router';
import {ModalsModule} from '../modals/modals.module';

@NgModule({
    declarations: [
        UpgradeComponent
    ],
    imports: [
        SharedModule,
        ButtonModule,
        DialogModule,
        CommonModule,
        CarouselModule,
        CarouselsModule,
        FormsModule,
        CountdownBannerComponent,
        StyleClassModule,
        RouterLink,
        ModalsModule
    ]
})
export class UpgradeModule { }
